import { render, staticRenderFns } from "./SeletorContextoCard.vue?vue&type=template&id=17f41750&scoped=true&lang=pug"
import script from "./SeletorContextoCard.vue?vue&type=script&lang=js"
export * from "./SeletorContextoCard.vue?vue&type=script&lang=js"
import style0 from "./SeletorContextoCard.vue?vue&type=style&index=0&id=17f41750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f41750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VSelect,VSpacer})
